
        import '/home/builduser/work/97f164ade279074e/santa-editor/packages/zoomMode/components/SiteSegmentIndication/SiteSegmentIndication.scss.css.virtualfile';
        module.exports = {"content":"_content_j1cfj_7","infoIcon":"_infoIcon_j1cfj_12","area":"_area_j1cfj_15"};